import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { isPVQForm } from 'helpers/form';
import { DEFAULT_EARLIEST, DEFAULT_LATEST } from 'constants/dateLimits';
import { evictionEntityTypes } from 'constants/enums/financialOptions';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { hasYesOrNo } from 'models/validate';
import { setToStartOfMonth } from 'helpers/date';
import { FinancialEvictionItemModel } from '../types';
import { pvqEvictionLocationValidator } from './pvqEvictionLocationValidator';

export const pvqFinancialEvictionItemValidator: ValidateJSModel<FinancialEvictionItemModel> = {
  EntityType: {
    hasValue: {
      validator: {
        inclusion: {
          within: evictionEntityTypes,
        }
      }
    }
  },

  EntityTypeExplain: (value, attributes) => {
    if (attributes.EntityType?.value === 'Other') {
      return { hasValue: true };
    }

    return {};
  },

  EntityName: (value, attributes) => {
    if (attributes?.EntityType?.value === 'Company' || attributes?.EntityType?.value === 'Government Agency') {
      return { hasValue: true };
    }

    return {};
  },

  PrivateName: (value, attributes) => {
    if (attributes.EntityType?.value === 'Individual') {
      return {
        model: {
          validator: pvqNameModelValidator,
        },
      };
    }

    return {};
  },

  PropertyLocation: {
    presence: true,
    location: {
      validator: pvqEvictionLocationValidator,
    },
  },

  HasMissedRent: {
    presence: true,
    hasValue: true
  },

  FirstPastDue: (value, attributes, attributeName, options) => {
    if (attributes?.HasMissedRent?.value !== 'Yes') { return {}; }
    return {
      presence: true,
      date: {
        earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
        latest: DEFAULT_LATEST
      },
    };
  },

  NumberMissed: (value, attributes, attributeName, options) => {
    if (attributes.HasMissedRent?.value !== 'Yes') { return {}; }
    return { hasValue: true };
  },

  AmountOwed: (value, attributes, attributeName, options) => {
    if (attributes.HasMissedRent?.value !== 'Yes') { return {}; }
    return {
      hasValue: true,
      model: {
        validator: currencyModelValidator,
      },
    };
  },

  AmountOwedEstimated: {},

  Current: {
    hasValue: {
      validator: hasYesOrNo,
    },
  },

  Why: (value, attributes, attributeName, options) => {
    if (attributes.HasMissedRent?.value !== 'Yes') { return {}; }
    return { hasValue: true };
  },

  When: (value, attributes, attributeName, options) => ({
    presence: true,
    date: {
      earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
      latest: DEFAULT_LATEST,
      requireDay: false
    },
  }),

  WhenEstimated: {},

  WhenResolved: (value, attributes, attributeName, options) => {
    if (attributes?.Current?.value === 'No') {
      return {
        presence: true,
        date: {
          earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
          latest: DEFAULT_LATEST,
          requireDay: false
        },
      };
    }

    return {};
  },

  WhenResolvedEstimated: {},

  ActionsTaken: (value, attributes) => {
    if (attributes?.Current?.value === 'Yes' && attributes?.ActionsTakenNone?.applicable !== false) {
      return { hasValue: true };
    }

    return {};
  },

  ActionsTakenNone: {},

  ActionsTakenReason: (value, attributes) => {
    if (attributes?.Current?.value === 'Yes' && attributes?.ActionsTakenNone?.applicable === false) {
      return { hasValue: true };
    }

    return {};
  },

  CourtName: (value, attributes) => {
    if (attributes?.CourtNameNotApplicable?.applicable !== false) {
      return { hasValue: true };
    }

    return {};
  },

  CourtNameNotApplicable: {},

  CourtLocation: {
    presence: true,
    location: {
      validator: pvqEvictionLocationValidator,
    }
  },

  OrderNum: (value, attributes) => {
    if (attributes?.OrderNumIdk?.applicable !== false) {
      return { hasValue: true };
    }

    return {};
  },

  OrderNumIdk: {},
};
